export const products = [
  {
    id: 1,
    name_bn: "রসুনের আচার",
    name_en: "Garlic Pickle",
    description_bn: "মায়ের হাতে তৈরি রসুনের আচার, যা আপনার খাবারের স্বাদ বাড়িয়ে তুলবে।",
    price: "২৮০",
    image: "/images/garlic-pickle.jpg",
    category: "আচার"
  },
  {
    id: 2,
    name_bn: "জলপাই আচার",
    name_en: "Olive Pickle",
    description_bn: "তাজা জলপাই দিয়ে তৈরি সুস্বাদু আচার, যা আপনার খাবারের সাথে চমৎকার মানাবে।",
    price: "৩২০",
    image: "/images/olive-pickle.jpg",
    category: "আচার"
  },
  {
    id: 3,
    name_bn: "আমের আচার",
    name_en: "Mango Pickle",
    description_bn: "কাঁচা আম দিয়ে তৈরি টক-ঝাল আচার, যা আপনার খাবারের স্বাদে নতুন মাত্রা যোগ করবে।",
    price: "২৫০",
    image: "/images/mango-pickle.jpg",
    category: "আচার"
  },
  {
    id: 4,
    name_bn: "মরিচ আচার",
    name_en: "Chili Pickle",
    description_bn: "ঝাল মরিচ দিয়ে তৈরি সুস্বাদু আচার, যা আপনার খাবারের স্বাদে তীব্রতা যোগ করবে।",
    price: "২০০",
    image: "/images/chili-pickle.jpg",
    category: "আচার"
  },
  {
    id: 5,
    name_bn: "লেবুর আচার",
    name_en: "Lemon Pickle",
    description_bn: "তাজা লেবু দিয়ে তৈরি টক-ঝাল আচার, যা আপনার খাবারের সাথে চমৎকার মানাবে।",
    price: "২২০",
    image: "/images/lemon-pickle.jpg",
    category: "আচার"
  },
  {
    id: 6,
    name_bn: "কাঁচা মরিচের আচার",
    name_en: "Green Chili Pickle",
    description_bn: "কাঁচা মরিচ দিয়ে তৈরি সুস্বাদু আচার, যা আপনার খাবারের স্বাদে নতুন মাত্রা যোগ করবে।",
    price: "১৮০",
    image: "/images/chili-pickle.jpg", // Using chili-pickle image as fallback
    category: "আচার"
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop&crop=center",
    alt: "বাংলাদেশি গ্রামের রান্নাঘর"
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=600&h=400&fit=crop&crop=center",
    alt: "ঐতিহ্যবাহী রান্নার দৃশ্য"
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1574484284002-952d92456975?w=600&h=400&fit=crop&crop=center",
    alt: "বাংলাদেশি মসলা ও উপকরণ"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop&crop=center",
    alt: "গ্রামীণ পরিবেশে রান্না"
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=600&h=400&fit=crop&crop=center",
    alt: "ঐতিহ্যবাহী খাবার প্রস্তুতকরণ"
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=600&h=400&fit=crop&crop=center",
    alt: "ঘরোয়া খাবার পরিবেশন"
  }
];

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&h=600&fit=crop&crop=center",
    title: "ঘরোয়া খাবার — মায়ের হাতে তৈরি স্বাদের ছোঁয়া",
    subtitle: "প্রকৃত স্বাদের সন্ধানে"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=1200&h=600&fit=crop&crop=center",
    title: "ঘরোয়া খাবার — প্রাচীন রেসিপির আধুনিক স্বাদ",
    subtitle: "প্রতিটি মুখে হাসি"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200&h=600&fit=crop&crop=center",
    title: "ঘরোয়া খাবার — স্বাস্থ্যকর ও সুস্বাদু",
    subtitle: "ভালোবাসার স্বাদ"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200&h=600&fit=crop&crop=center",
    title: "ঘরোয়া খাবার — পরিবারের জন্য বিশেষ",
    subtitle: "প্রতিটি বেলায় তৃপ্তি"
  }
];